var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7591 6.15723V12.404",
    stroke: "#231D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5593 6.15723V12.404",
    stroke: "#221D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15668 15.1232H28.86",
    stroke: "#F25C54",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38395 10.0352H26.9342C28.1644 10.0352 29.1614 11.0322 29.1614 12.2624V27.4688C29.1614 28.699 28.1644 29.696 26.9342 29.696H8.38395C7.15375 29.696 6.15668 28.699 6.15668 27.4688V12.2624C6.15668 11.0322 7.15375 10.0352 8.38395 10.0352Z",
    stroke: "#221D1D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9632 20.3421C12.9632 20.9064 12.5059 21.363 11.9424 21.363C11.3789 21.363 10.9215 20.9064 10.9215 20.3421C10.9215 19.7786 11.3789 19.3213 11.9424 19.3213C12.5059 19.3213 12.9632 19.7786 12.9632 20.3421Z",
    fill: "#221D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.68 20.3421C18.68 20.9064 18.2227 21.363 17.6592 21.363C17.095 21.363 16.6384 20.9064 16.6384 20.3421C16.6384 19.7786 17.095 19.3213 17.6592 19.3213C18.2227 19.3213 18.68 19.7786 18.68 20.3421Z",
    fill: "#221D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3965 20.3421C24.3965 20.9064 23.9399 21.363 23.3757 21.363C22.8122 21.363 22.3548 20.9064 22.3548 20.3421C22.3548 19.7786 22.8122 19.3213 23.3757 19.3213C23.9399 19.3213 24.3965 19.7786 24.3965 20.3421Z",
    fill: "#221D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9632 25.2425C12.9632 25.806 12.5059 26.2633 11.9424 26.2633C11.3789 26.2633 10.9215 25.806 10.9215 25.2425C10.9215 24.6783 11.3789 24.2217 11.9424 24.2217C12.5059 24.2217 12.9632 24.6783 12.9632 25.2425Z",
    fill: "#221D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.68 25.2425C18.68 25.806 18.2227 26.2633 17.6592 26.2633C17.095 26.2633 16.6384 25.806 16.6384 25.2425C16.6384 24.6783 17.095 24.2217 17.6592 24.2217C18.2227 24.2217 18.68 24.6783 18.68 25.2425Z",
    fill: "#221D1D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3965 25.2425C24.3965 25.806 23.9399 26.2633 23.3757 26.2633C22.8122 26.2633 22.3548 25.806 22.3548 25.2425C22.3548 24.6783 22.8122 24.2217 23.3757 24.2217C23.9399 24.2217 24.3965 24.6783 24.3965 25.2425Z",
    fill: "#221D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/Calendar 2.b96c625abb7bde5e754dfcabea3d9af1.svg";
export { ForwardRef as ReactComponent };